function Footer() {
  return (
    <div className="hero navbar-style is-small has-text-centered">
      <div className="hero-foot">
        <p>Built by Ornella Spada, Elsa Guibert, Gursham Singh, Paolo Zuccaro</p>
      </div>
    </div>
    
  )
}

export default Footer